/* eslint-disable react/jsx-props-no-spreading */
import { faChevronLeft } from '@awesome.me/kit-5452b20ec3/icons/classic/solid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import React from 'react'
import { Link, LinkProps } from 'react-router-dom'

import styles from './BackLink.module.scss'
interface BackLinkProps extends LinkProps {
  label: string
  show?: boolean
}

const BackLink = ({ label, show = true, className, ...rest }: BackLinkProps) => {
  if (!show) return null

  return (
    <Link className={classNames(styles['back-button'], className)} {...rest}>
      <FontAwesomeIcon icon={faChevronLeft} className={styles['back-button-icon']} />
      {label}
    </Link>
  )
}

export default BackLink
